export interface IOverflowButtonState {
  currentlyOpenOverflowButtonId?: string;
}

export const overflowButtonState: IOverflowButtonState = {
  currentlyOpenOverflowButtonId: undefined,
};
